import React from 'react';
import {arrayOf, bool, func, object} from 'prop-types';
import {Grid} from 'semantic-ui-react';
import {DropTarget} from 'react-dnd';
import MasterStep from './MasterStep';
import {EmptyFunc} from "../../utils/DBUtils";
import {displayOrderSort} from "../../utils/collectionManagmentUtils";

const stepTarget = {
  // steps can only swap positions with each other; they cannot be dropped on the
  // containing column itself.
  drop() {}
};

const MasterColumn = ({
  width,
  steps = [],
  breakObj = {},
  sortable = false,
  connectDropTarget,
  findStep,
  moveStep,
    togglePublishStep,
    deleteStep,
    renameStep,
    onStepClick
}) => {
  let displaySteps = steps.filter((step) => !step.deleted);
  displaySteps.sort(displayOrderSort);
  const column = (
    <div className="master-column-container">
      <Grid.Column width={width}>
        {displaySteps.map((step) => (
          <Grid.Row className="master-column-row" width={10} key={step.id}>
            <MasterStep
                id={step.id}
                active={step.publishStep}
                stepType={step.type}
                stepLabel={step.internalLabel}
                breakObj={breakObj}
                sortable={sortable}
                onClick={() => onStepClick(step)}
                togglePublishStep={() => togglePublishStep(step)}
                deleteStep={() => deleteStep(step)}
                renameStep={() => renameStep(step)}
                findStep={findStep}
                moveStep={moveStep} />
          </Grid.Row>
        ))}
      </Grid.Column>
    </div>
  );

  return sortable ? connectDropTarget(column) : column;
};

MasterColumn.propTypes = {
  steps: arrayOf(object),
  sortable: bool,
  connectDropTarget: func.isRequired,
  findStep: func.isRequired,
  moveStep: func.isRequired,
    onStepClick: func,
    togglePublishStep: func,
    deleteStep: func,
    renameStep: func
};

MasterColumn.defaultProps = {
    deleteStep: EmptyFunc,
    deactivateStep: EmptyFunc,
    renameStep: EmptyFunc,
    onClick: EmptyFunc
};

export default DropTarget('masterStep', stepTarget, connect => ({
  connectDropTarget: connect.dropTarget()
}))(MasterColumn);



// WEBPACK FOOTER //
// ./public/components/steps/MasterColumn.jsx